###
Hacky temporary object to pass data from the SPP (not angularized) into the
planting form (angularized), since there isn't really any nice way of doing it.
Once the SPP is angularized, it might be possible to replace this with an
injectable service that stores the data.
###
class exports.PlantingOptions
    constructor: (options = {}) ->
        @company_id = options.company_id
        @crop_id = options.crop_id
        @spp_id = options.spp_id
        @fsr_id = options.fsr_id
        @survey_result_id = options.survey_result_id

        @sppPlantingPlan = options.sppPlantingPlan
        @sppPlanterSubscription = options.sppPlanterSubscription
        @sppProductSubscription = options.sppProductSubscription

        @calculate_population = options.calculate_population
        @sppPopulationAdjustment = options.sppPopulationAdjustment
        # min_max_pop should be an object with min_pop and max_pop properties
        @min_max_pop = options.min_max_pop

        # events should be a nested array of product IDs
        @events = options.events
